import { useState } from "react";
import styled from "styled-components";
import CustomIcon from "../Icons/CustomIcon";
import Theme from "../../../styles/Theme/Theme";

const SearchBarContainer = styled.div`
    height: 32px;
    background: ${Theme.color["neutral-2"]};
    border-radius: 32px;

    display: flex;
    align-items: center;

    .icon{
        margin: 0 ${Theme.spacing.s04};
    }
`;

const TextContent = styled.input`
    font-family: ${Theme.typography.fontFamily};
    font-size: ${Theme.typography.fontSize.text_sm_desktop};
    color: ${Theme.color["coolgray-10"]};
    background: none;
    border: none;
    outline: none;
    width: auto;

    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${Theme.color["coolgray-10"]};
        opacity: 1; /* Firefox */
    }
`;


export const SearchBar = ({ filterWithSearch, customInput, disabled }) => {
    const [searchText, setSearchText] = useState('');

    function search(value) {
        setSearchText(value);
        filterWithSearch(value);
    }

    return (
        <SearchBarContainer>
            <CustomIcon icon={'Search'} color='blue-4' iconsize='xs' />
            <TextContent placeholder={customInput?.placeholder} value={searchText} onChange={(e) => search(e.target.value)} disabled={disabled} />
            <CustomIcon icon={'Clear'} visibility={searchText !== '' ? null : 'hidden'} onClick={() => { search('') }} />
        </SearchBarContainer>
    );
};